import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import RecallCategoryView from "../../Models/Recall/RecallCategoryView";

export default () =>
  axiosApi.get<RecallCategoryView[]>(
    `${BackendServices.RECALL_SERVICE.RECALL}/Categories`
  );
